/**
 * we want to always show at most 9 total items, including the ellipsis items.
 * there will be 5 page items in between the ellipses when both the start and end ellipses are shown.
 *
 * @param pageInfo - object containing current page and total pages info
 * @returns An array of up to 9 total items representing page numbers and ellipses when applicable
 */
export const getPages = ({ currentPage, totalPages }) => {
    let pages = [];
    if (totalPages <= 9) {
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
    }
    else if (currentPage > 5 && currentPage < totalPages - 4) {
        pages = [
            1,
            '...',
            currentPage - 2,
            currentPage - 1,
            currentPage,
            currentPage + 1,
            currentPage + 2,
            '...',
            totalPages,
        ];
    }
    else if (currentPage >= totalPages - 4) {
        pages = [
            1,
            '...',
            totalPages - 6,
            totalPages - 5,
            totalPages - 4,
            totalPages - 3,
            totalPages - 2,
            totalPages - 1,
            totalPages,
        ];
    }
    else {
        pages = [1, 2, 3, 4, 5, 6, 7, '...', totalPages];
    }
    return pages;
};
//# sourceMappingURL=get_pages.js.map